import Configurator from '../../configurator'

export default class MessengerBase extends Configurator {}
